import { ReactNode } from 'react';
import { Workbox } from './Workbox';
import { MyUniversalWorklist } from './MyUniversalWorklist';
import { ConfigHelper, Feature } from '@devxdiscover/devhub-common';
import {
  DevHubBox,
  DevHubButton,
  DevHubTypography,
} from '@devxdiscover/devhub-ui';
import { useNavigate } from 'react-router-dom';
import { MySummary } from './MySummary';
import { MyTickets } from './MyTickets';
import { PrivacyWork } from './PrivacyWork';

export type ConfigFeatureProps = { children: ReactNode } & { feature: Feature };

/**
 * A component that displays a summary of incidents and other notable activities for authenticated user.
 * @constructor
 */
export const MyWork = () => {
  const navigate = useNavigate();
  const uwlEnabled = ConfigHelper.instance.isFeatureEnabled(
    Feature.UNIVERSAL_WORKLIST,
  );

  const handleViewAll = (component: string) => {
    navigate(`/action-center/${component}`);
  };

  return (
    <>
      <Workbox
        autoHeight
        color="purple"
        title="My Work"
        subHeader="All your projects & user stories are here"
      >
        {/* UNIVERSAL WORKLIST */}
        <MyUniversalWorklist />
        {/* MY SUMMARY */}
        <DevHubBox tbPadding="large" display="flex" alignItems="center">
          <DevHubTypography>My Pull Requests & Incidents</DevHubTypography>
          <DevHubButton
            buttonColor="themeBased"
            onClick={() => handleViewAll('my-summary')}
          >
            <DevHubTypography fontColor="blue" fontSize="small">
              View All
            </DevHubTypography>
          </DevHubButton>
        </DevHubBox>
        <MySummary />
        {/* MY TICKETS */}
        <DevHubBox tbPadding="large" display="flex" alignItems="center">
          <DevHubTypography>My Tickets</DevHubTypography>
          <DevHubButton
            buttonColor="themeBased"
            onClick={() => handleViewAll('my-tickets')}
          >
            <DevHubTypography fontColor="blue" fontSize="small">
              View All
            </DevHubTypography>
          </DevHubButton>
        </DevHubBox>
        <MyTickets />
        {/* Privacy Tasks */}
        {!uwlEnabled && <PrivacyWork showCount />}
      </Workbox>
    </>
  );
};
